import { Heading } from '@portal/components'
import { Container } from 'components/layout'
import React from 'react'

interface Props {
  headerContent?: string | React.ReactNode
  children: React.ReactNode
}

/** Applies the main layout of the application to the provided children. */
export default function MainLayout({ headerContent, children }: Props) {
  const header =
    headerContent && typeof headerContent === 'string' ? (
      <Heading level={1} className="leading-tight">
        {headerContent}
      </Heading>
    ) : (
      headerContent
    )

  return (
    <div className="py-12">
      {header && (
        <header>
          <Container>{header}</Container>
        </header>
      )}
      <main>{children}</main>
    </div>
  )
}
